import { jsx as _jsx } from "react/jsx-runtime";
import { pathgen } from 'object-path-generator';
import { ConfirmationModal } from 'seagull';
import { CardButtonGrid } from '~/components/CardButtonGrid/CardButtonGrid';
import { useLocaleKeys } from '~/i18n';
import styles from './SelectNewServiceTypeModal.module.scss';
export var NewServiceType = /*#__PURE__*/ function(NewServiceType) {
    NewServiceType["Service"] = "service";
    NewServiceType["Bundle"] = "bundle";
    return NewServiceType;
}({});
export const SelectNewServiceTypeModalTID = pathgen('SelectNewServiceTypeModalTID');
const buttonTypeToTestId = {
    ["service"]: SelectNewServiceTypeModalTID.Service(),
    ["bundle"]: SelectNewServiceTypeModalTID.Bundle()
};
const buttonTypeToBiName = {
    ["service"]: 'create_new_service',
    ["bundle"]: 'create_new_bundle'
};
export function SelectNewServiceTypeModal(param) {
    let { dismissModal } = param;
    const { t: texts } = useLocaleKeys('components.addServicesButton');
    const { t: typeTexts } = useLocaleKeys('components.addServicesButton.selectType');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'select_new_service_type_confirm'
            },
            secondaryButton: {
                name: 'select_new_service_type_cancel'
            }
        },
        showFooter: false,
        title: texts.createNewTitle(),
        width: "540px",
        testId: SelectNewServiceTypeModalTID.Root(),
        onCloseButtonClick: ()=>dismissModal(),
        contentClassName: styles.content,
        content: /*#__PURE__*/ _jsx(CardButtonGrid, {
            items: [
                {
                    title: typeTexts.createNewService(),
                    description: typeTexts.newServiceContent(),
                    testId: buttonTypeToTestId["service"],
                    bi: {
                        name: buttonTypeToBiName["service"]
                    },
                    onClick: ()=>dismissModal("service")
                },
                {
                    title: typeTexts.createNewBundle(),
                    description: typeTexts.newBundleContent(),
                    testId: buttonTypeToTestId["bundle"],
                    bi: {
                        name: buttonTypeToBiName["bundle"]
                    },
                    onClick: ()=>dismissModal("bundle")
                }
            ]
        })
    });
}
